<template>
    <div class="com-codics-book-admin-body">
        <MySideBar v-model="isShow" :style="{ 'width': isShow ? '256px' : '50px' }" :data="leftBarData"
            :config="sideConfig"></MySideBar>
        <div class="com-codics-book-admin-body-contanier" :style="{ 'padding-left': isShow ? '256px' : '50px' }">
            <AdminHeader></AdminHeader>
            <router-view class="com-codics-book-admin-body-content"></router-view>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import MySideBar from '@/components/MySideBar';
import AdminHeader from '@/components/AdminHeader';
import { readData, saveData, jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            isShow: false,
            sideConfig: {
                header: {
                    icon: '<img src="https://cdn.bosscaigou.com/huayuan/img/yasuo_60bc7e65a6d385d503656e12772d226.webp" style="height:100%;width:100%;box-sizing:border-box;overflow:hidden;object-fit:contain;border-radius:4px;">',
                    title: "管理后台",
                    version: "v 1.0.0"
                },
                footer: {

                }
            },
            leftBarData: [
                // {
                //     id: 'template-nav',
                //     icon: "&#xF25C;",
                //     title: "用户管理",
                //     state: false,
                //     child: [
                //         {
                //             title: "用户管理",
                //             url: "#"
                //         },
                //         {
                //             title: "角色管理",
                //             url: "#"
                //         },
                //         {
                //             title: "菜单管理",
                //             url: "#"
                //         },
                //     ]
                // },
                {
                    id: 'template-nav',
                    icon: "&#xF3A9;",
                    title: "产品管理",
                    state: false,
                    child: [
                        {
                            title: "产品管理",
                            url: "#"
                        },
                        {
                            title: "产品分类管理",
                            url: "#"
                        }
                    ]
                },
                {
                    id: 'article-nav',
                    icon: "&#xEB0F;",
                    title: "案例管理",
                    state: false,
                    child: [
                        {
                            title: "案例管理",
                            url: "#"
                        },
                        {
                            title: "案例分类管理",
                            url: "#"
                        }
                    ]
                },
                {
                    id: 'article-nav',
                    icon: "&#xEA7E;",
                    title: "新闻管理",
                    state: false,
                    child: [
                        {
                            title: "新闻管理",
                            url: "#"
                        },
                        {
                            title: "新闻分类管理",
                            url: "#"
                        }
                    ]
                },
                {
                    icon: "&#xF431;",
                    title: "反馈管理",
                    state: false,
                    child: [
                        {
                            title: "反馈管理",
                            url: "#"
                        }
                    ]
                }
            ]
        }
    },
    beforeMount() {
    },
    mounted() {
    },
    components: {
        MySideBar,
        AdminHeader
    },
    computed: {
        ...mapState(['userInfo'])
    },
    methods: {
    },
    watch: {
    }
}
</script>

<style>
.com-codics-book-admin-body {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    padding: 0;
    margin: 0;
    background: #FBFBFB;
    box-sizing: border-box;
    transition: .3s all ease;
}

.com-codics-book-admin-body-contanier {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    transition: .3s all ease;
}

.com-codics-book-admin-body-content {
    height: calc(100% - 50px) !important;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    transition: .3s all ease;
    overflow-y: auto !important;
}
</style>